import { StorageNameEnum } from '../../common/types/storage'
import { isString } from '../../common/types/typeGuards'

export const getAccessToken = () => {
  const storageItem = localStorage.getItem(StorageNameEnum.TOKEN)
  if (!storageItem) return null

  const accessToken = JSON.parse(storageItem).content.access_token
  if (!isString(accessToken)) return null

  return accessToken
}
